import Select from "Components/Select/Select";

export default Select;
